import { TestIdClassNameProps } from "@app/types/Common";
import { Section, Tag } from "@app/types/Cue";
import cx from "classnames";

import { NewsletterFactory } from "./NewsletterFactory";

export type ArticleNewsletterProps = TestIdClassNameProps & {
  sections: Section[];
  tags: Tag[];
};
export default function ArticleNewsletter({
  testId,
  rootClassName,
  tags,
  sections,
}: ArticleNewsletterProps): React.ReactElement {
  return (
    <div
      className={cx(rootClassName, "border-y-2 border-gray-850")}
      data-testid={testId}
    >
      <NewsletterFactory sections={sections} tags={tags} />
    </div>
  );
}
